<template>
  <div class="sideFilters">

    <div class="sideFilters__type">
      <div class="sideFilters__type__name">
        <span>{{ $t('audit.model_type') }}</span>
        <i class="el-icon-close"v-on:click="this.resetModelFilters" ></i>
      </div>
      <div v-for="filter in this.filtersType1">
        <div class="sideFilters__type__filters">
          <input
            type="checkbox"
            :name="filter.name"
            :value="filter.value"
            :checked="modelTypeFilters.includes(filter.value) ? true : false"
            v-on:click="() => toggleFilterStatus('model', filter.value)"
          />
          <label>{{ $t('audit.side_filters.'+filter.name) }}</label>
        </div>
      </div>
    </div>

    <div class="sideFilters__type">
      <div class="sideFilters__type__name">
        <span>{{ $t('audit.event_type')}}</span>
        <i class="el-icon-close" @click="this.resetEventFilters"></i>
      </div>
      <div v-for="filter in this.filtersType2">
        <div class="sideFilters__type__filters">
          <input
            type="checkbox"
            :name="filter.name"
            :value="filter.value"
            v-on:click="() => toggleFilterStatus('event', filter.value)"
            :checked="eventTypeFilters.includes(filter.value) ? true : false"
          />
          <label>{{ $t('audit.side_filters.'+filter.name) }}</label>
        </div>
      </div>
    </div>

    <div class="sideFilters__buttons">
      <button
        type="submit"
        class="sideFilters__buttons__apply"
        :class="(filtersAmount > 0) && 'hasActiveFilters'"
        v-on:click="() => handleApplyFilters()"
      >
        {{ $t('audit.apply_filters') }}
      </button>
      <button type="submit" class="btn btn--secondary" v-on:click="this.toggleShowFilters">
        {{ $t('audit.hide_filters') }}
      </button>
    </div>
  </div>
</template>

<script>

import { mapGetters } from "vuex";

export default {
  name: "AuditSideFilters",
  computed: {
    ...mapGetters({
      showFilters: 'audit/audit/showFilters',
      eventTypeFilters: 'audit/audit/eventTypeFilters',
      modelTypeFilters: 'audit/audit/modelTypeFilters',
    }),
    filtersAmount() {
      return this.eventTypeFilters.length + this.modelTypeFilters.length;
    },
  },
  data() {
    return {
      modelFilters: this.modelTypeFilters ? this.modelTypeFilters : [],
      eventFilters: this.eventTypeFilters ? this.eventTypeFilters : [],
      filtersType1: [
        { name: 'parking', value: 'Parking' },
        { name: 'parking_card', value: 'ParkingCard' },
        { name: 'partner', value: 'Partner' },
        { name: 'product', value: 'Product' },
        { name: 'zone', value: 'Zone' },
        { name: 'vehicle', value: 'Vehicle' },
        { name: 'user', value: 'User' },
      ],
      filtersType2: [
        { name: 'created', value: 'created' },
        { name: 'updated', value: 'updated' },
        { name: 'deleted', value: 'deleted' },
      ]
    };
  },
  methods: {
    resetModelFilters() {
      this.$store.dispatch('audit/audit/setModelTypeFilter', []);
      this.modelFilters = [];
    },
    resetEventFilters() {
      this.$store.dispatch('audit/audit/setEventTypeFilter', []);
      this.eventFilters = [];
    },
    handleApplyFilters() {
      this.$emit('set-current-page', 1);
      this.$store.dispatch('audit/audit/setIsFetchDataNeeded', true);
      this.toggleShowFilters();
    },
    toggleShowFilters() {
      this.$store.dispatch('audit/audit/setShowFilters', !this.showFilters);
    },
    toggleFilterStatus(type, filterValue) {
      if (type === 'model') {
        if (this.modelFilters.length === 0) {
          this.modelFilters.push(filterValue);
        } else {
          this.modelFilters = this.modelFilters.includes(filterValue)
            ? this.modelFilters.filter((item) => item !== filterValue)
            : [...this.modelFilters, filterValue];
        }
        this.$store.dispatch(`audit/audit/setModelTypeFilter`, this.modelFilters);
      } else if (type === 'event') {
        if (this.eventFilters.length === 0) {
          this.eventFilters.push(filterValue)
        } else {
          this.eventFilters = this.eventFilters.includes(filterValue)
            ? this.eventFilters.filter((item) => item !== filterValue)
            : [...this.eventFilters, filterValue];
        }
        this.$store.dispatch(`audit/audit/setEventTypeFilter`, this.eventFilters);
      } else {
        console.log('Filter does not exist');
      }
    }
  },
};

</script>

<style lang="scss">
  @import './Audit.scss';
</style>




// WEBPACK FOOTER //
// src/components/audit/AuditSideFilters.vue